module.exports = __webpack_public_path__ + "static/media/gsb_ipb_logo.054b50e2.png";